var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardFill1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dashboard_FILL1_wght400_GRAD0_opsz24",
    d: "M131-834a.967.967,0,0,1-.712-.288A.967.967,0,0,1,130-835v-4a.968.968,0,0,1,.288-.713A.968.968,0,0,1,131-840h6a.968.968,0,0,1,.713.287A.968.968,0,0,1,138-839v4a.967.967,0,0,1-.287.712A.967.967,0,0,1,137-834Zm-10,4a.968.968,0,0,1-.713-.287A.968.968,0,0,1,120-831v-8a.968.968,0,0,1,.287-.713A.968.968,0,0,1,121-840h6a.968.968,0,0,1,.713.287A.968.968,0,0,1,128-839v8a.968.968,0,0,1-.287.713A.968.968,0,0,1,127-830Zm10,8a.967.967,0,0,1-.712-.288A.967.967,0,0,1,130-823v-8a.968.968,0,0,1,.288-.713A.968.968,0,0,1,131-832h6a.968.968,0,0,1,.713.287A.968.968,0,0,1,138-831v8a.967.967,0,0,1-.287.712A.967.967,0,0,1,137-822Zm-10,0a.967.967,0,0,1-.713-.288A.967.967,0,0,1,120-823v-4a.968.968,0,0,1,.287-.713A.968.968,0,0,1,121-828h6a.968.968,0,0,1,.713.287A.968.968,0,0,1,128-827v4a.967.967,0,0,1-.287.712A.967.967,0,0,1,127-822Z",
    transform: "translate(-120 840)",
    fill: "#5a5a5a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFill1);
export default __webpack_public_path__ + "static/media/dashboard_FILL1.8e5c731c96236c7baf436b423b1d6dc2.svg";
export { ForwardRef as ReactComponent };